export default "__VITE_ASSET__Mgc3DuEg__"